import { render, staticRenderFns } from "./briefing_report.vue?vue&type=template&id=19732672&scoped=true"
import script from "./briefing_report.vue?vue&type=script&lang=js"
export * from "./briefing_report.vue?vue&type=script&lang=js"
import style0 from "./briefing_report.vue?vue&type=style&index=0&id=19732672&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19732672",
  null
  
)

export default component.exports